import { browser } from '$app/environment';
import { user } from '$lib/stores/auth';
import { derived, get, writable, type Writable } from 'svelte/store';
import { filterUser, taskFilterMap } from './tasks';

const SEPARATOR = '||';

const createStore = <T extends string | number | boolean>(
	key: string,
	fallbackValue: T
): Writable<T> => {
	let initialValue: string | number | boolean;
	let searchParams;

	if (browser) {
		searchParams = new URLSearchParams(window.location.search);

		if (searchParams.has(key)) {
			if (typeof fallbackValue === 'string' || typeof fallbackValue === 'boolean') {
				initialValue = searchParams.get(key);
			}
			if (typeof fallbackValue === 'number') {
				initialValue = parseInt(searchParams.get(key), 10);
			}
		} else {
			initialValue = fallbackValue;
		}
	} else {
		initialValue = fallbackValue;
	}

	const { set, update, subscribe } = writable(initialValue as T);

	return {
		set,
		update,
		subscribe,
	};
};

const createArrayStore = (key: string) => {
	let objectSet: Set<string> = new Set();
	let initialValue: string[];
	let searchParams;

	if (browser) {
		searchParams = new URLSearchParams(window.location.search);

		if (searchParams.has(key)) {
			initialValue = searchParams.get(key).split(SEPARATOR);
		} else {
			initialValue = [];
		}
	} else {
		initialValue = [];
	}

	const { set, update, subscribe } = writable(initialValue);

	return {
		set: (value: string[]) => {
			objectSet = new Set();
			value.forEach((id) => objectSet.add(id));

			set(value);
		},
		update,
		subscribe,
		remove: (id: string) => {
			if (objectSet.has(id)) {
				objectSet.delete(id);
			}
			const objectArray = [...objectSet];

			set(objectArray);
		},
	};
};
export const query = createStore('query', '' as string);
export const filteredDistricts = createArrayStore('districts');
export const filteredPeople = createArrayStore('people');
export const filteredThemes = createArrayStore('themes');
export const filteredIconclasses = createArrayStore('iconclasses');
export const filteredUnclearPeople = createStore('unclearPeople', false);
export const filteredUnclearDatings = createStore('unclearDatings', false);
export const filteredTask: Writable<Task | ''> = createStore('task', '');
export const filteredGeo = createStore('geo', '' as string);
export const filterIsVisible = writable(false);

export const searchParams = derived(
	[
		query,
		filteredDistricts,
		filteredPeople,
		filteredThemes,
		filteredIconclasses,
		filteredUnclearPeople,
		filteredUnclearDatings,
		filteredTask,
		filteredGeo,
	],
	([
		query,
		filteredDistricts,
		filteredPeople,
		filteredThemes,
		filteredIconclasses,
		filteredUnclearPeople,
		filteredUnclearDatings,
		filteredTask,
		filteredGeo,
	]) => {
		const record = [
			['query', query + ''],
			['districts', filteredDistricts.join(SEPARATOR)],
			['people', filteredPeople.join(SEPARATOR)],
			['themes', filteredThemes.join(SEPARATOR)],
			['iconclasses', filteredIconclasses.join(SEPARATOR)],
			['unclearPeople', filteredUnclearPeople],
			['unclearDatings', filteredUnclearDatings],
			['task', filteredTask + ''],
			// ['geo', filteredGeo + ''],
		].filter(([key, value]) => value);

		return new URLSearchParams(record);
	}
);
